<template>
  <section class="section" :id="`uuid-${model.uuid}`">
    <div class="section__container">
      <div class="grid-x align-center motoplex--custom">
        <div class="cell large-12">
          <b-tabs v-model="tabIndex" content-class="nav-tabs-styled" nav-wrapper-class="nav-tabs-styled" @input="scrollIntoViewport">
            <b-tab
              v-for="(item, itemIndex) in model.tabsItem"
              :key="itemIndex"
              :active="isActive(itemIndex)"
              v-if="model.tabsItem"
            >
              <template v-slot:title>
                <pg-icon-text :iconName="item.iconName" :title="item.tabTitle" />

                <!--             <i :class="`icon icon-${item.iconName}`"></i>

                <span class="nav-tabs__title">{{item.tabTitle}}</span>-->
              </template>

              <editorial
                :title="item.title"
                :subtitle="item.subtitle"
                :text="item.text"
                :ctaLinks="item.ctaLinks || []"
                :image="item.image || {}"
                :layout="item.layout"
                :imageStyle="item.imageStyle"
                :textOnTwoColumns="item.textOnTwoColumns"
                :verticalTextAlign="item.verticalTextAlign"
                :actpageFullUrl="common.actpageFullUrl"
              />
            </b-tab>
          </b-tabs>
        </div>
      </div>
    </div>
  </section>
</template>

<script>
import { mgnlComponentMixin } from "@wl-vue-mixins/mixins.js";
import PgImage                from "../Image/Image.vue";
import PgButton from "../Button/Button.vue";
import Tabs from "bootstrap-vue";
import Editorial from "../Editorial/Editorial.vue";
import PgIconText from "../IconText/IconText.vue";

export default {
  mixins: [mgnlComponentMixin], // !!! all the mgnl components must be configured with mgnlComponentMixin !!!
  name: "editorial-tabs",
  components: {
    PgImage,
    PgButton,
    Tabs,
    Editorial,
    PgIconText
  },
  data() {
    return {
      tabIndex: 0
    };
  },
  methods: {
    isActive(index) {
      return index === 0;
    },
    scrollIntoViewport() {
      window.scrollTo({top: this.$el.getBoundingClientRect().top + window.scrollY - 70, behavior: "smooth"});
    }
  },
};
</script>